import Vue from "vue";
import Element from '@/plugins/element.js';


// 注册全局组件
Element.components.forEach(i => Vue.use(i));


// WEBPACK FOOTER //
// ./src/plugins/index.js